import { render } from "./SimplePieCircle.vue?vue&type=template&id=12582922&scoped=true"
import script from "./SimplePieCircle.vue?vue&type=script&lang=js"
export * from "./SimplePieCircle.vue?vue&type=script&lang=js"

import "./SimplePieCircle.vue?vue&type=style&index=0&id=12582922&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12582922"],['__file',"src/components/h5/board/SimplePieCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12582922"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12582922', __exports__)) {
    api.reload('12582922', __exports__)
  }
  
  module.hot.accept("./SimplePieCircle.vue?vue&type=template&id=12582922&scoped=true", () => {
    api.rerender('12582922', render)
  })

}


export default __exports__